module.exports = __webpack_public_path__ + "img/koubei.aa451d2f.png";